import * as tslib_1 from "tslib";
import { espTime2Seconds, StateObject } from "@hpcc-js/util";
import { WorkunitsService } from "../services/wsWorkunits";
var Timer = /** @class */ (function (_super) {
    tslib_1.__extends(Timer, _super);
    function Timer(optsConnection, wuid, eclTimer) {
        var _this = _super.call(this) || this;
        if (optsConnection instanceof WorkunitsService) {
            _this.connection = optsConnection;
        }
        else {
            _this.connection = new WorkunitsService(optsConnection);
        }
        var secs = espTime2Seconds(eclTimer.Value);
        _this.set(tslib_1.__assign({ Wuid: wuid, Seconds: Math.round(secs * 1000) / 1000, HasSubGraphId: eclTimer.SubGraphId !== undefined }, eclTimer));
        return _this;
    }
    Object.defineProperty(Timer.prototype, "properties", {
        get: function () { return this.get(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Timer.prototype, "Wuid", {
        get: function () { return this.get("Wuid"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Timer.prototype, "Name", {
        get: function () { return this.get("Name"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Timer.prototype, "Value", {
        get: function () { return this.get("Value"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Timer.prototype, "Seconds", {
        get: function () { return this.get("Seconds"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Timer.prototype, "GraphName", {
        get: function () { return this.get("GraphName"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Timer.prototype, "SubGraphId", {
        get: function () { return this.get("SubGraphId"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Timer.prototype, "HasSubGraphId", {
        get: function () { return this.get("HasSubGraphId"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Timer.prototype, "count", {
        get: function () { return this.get("count"); },
        enumerable: true,
        configurable: true
    });
    return Timer;
}(StateObject));
export { Timer };
//# sourceMappingURL=timer.js.map